require('./mortgageRequestDataProprietorBodyItem.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { formatText } = require('core/i18n').i18n;
const { get } = require('lodash');
const { Link } = require('react-router-dom');
const OKStatusIcon = require('components/commons/OKStatusIcon/OKStatusIcon');

// @components
const Modal = require('../modal');

// @constants
const mortgageRequestStates = require('constants/mortgageRequestStates');

class MortgageRequestDataProprietorBodyItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenModal: false
        };

        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleOnDelete = this.handleOnDelete.bind(this);
        this.buildDeleteButton = this.buildDeleteButton.bind(this);
    }

    getRoutesFromStatus(proprietorNum) {
        const { stepsValidation } = this.props;

        let linkPersonalData = `/myprofile/mortgage/co-holder-info/${proprietorNum}`;
        if (proprietorNum === 1) {
            linkPersonalData = `/myprofile/mortgage/holder-info/${proprietorNum}`;
        }

        const linkWorkData = `/myprofile/mortgage/holder-work/${proprietorNum}`;
        const linkEconomicData = `/myprofile/mortgage/holder-economic/${proprietorNum}`;

        const isPersonalData = stepsValidation.get(0);
        const isWorkData = stepsValidation.get(1);
        const isEconomicData = stepsValidation.get(2);

        let linksCollection = [linkPersonalData, linkWorkData, null];

        if (isPersonalData && !isWorkData && !isEconomicData) {
            linksCollection = [linkWorkData, linkWorkData, null];

        } else if (!isPersonalData && isWorkData  && !isEconomicData) {
            linksCollection = [linkPersonalData, linkPersonalData, null];

        } else if (isPersonalData && isWorkData && !isEconomicData) {
            linksCollection = [linkEconomicData, linkEconomicData, linkEconomicData];

        } else if (isPersonalData && isWorkData && isEconomicData) {
            linksCollection = [linkPersonalData, linkWorkData, linkEconomicData];
        }

        return linksCollection;
    }

    buildDeleteButton() {
        const { currentState } = this.props;

        if (currentState !== mortgageRequestStates.CONFIRMA_DATOS_T2) {
            return (
                <a
                    href="#"
                    className="mortgage-request-manager-panel-steps__delete"
                    onClick={this.handleModalOpen}
                >
                    <i className="icon-eliminar mortgage-request-manager-panel-steps__ico--eliminar" />
                </a>
            );
        } else {
            return '';
        }
    }

    configModalOptions() {
        const config = {
            handlers: {
                handleModalClose: this.handleModalClose,
                handleClickBtn: this.handleOnDelete
            }
        };
        return config;
    }

    handleModalClose() {
        this.setState({
            isOpenModal: false
        });
    }

    handleModalOpen(evt) {
        evt && evt.preventDefault();
        this.setState({
            isOpenModal: true
        });
    }

    handleOnDelete(evt) {
        evt && evt.preventDefault();
        const { onDelete, proprietorNum } = this.props;
        this.setState(
            {
                isOpenModal: false
            },
            () => {
                onDelete(proprietorNum).then(() => {
                    const { onRequestDataProprietor } = this.props;
                    onRequestDataProprietor();
                });
            }
        );
    }

    render() {
        const {
            proprietorNum,
            employmentSituation,
            documentLaboralLife,
            documentIrpf,
            ceaInfo,
            isApprovedDataProprietor,
            hideLinks,
            isCheckedCirbe,
            operationProcessId
        } = this.props;
        const dataProprietorHolderData = formatText('mortgageRequestPanel-dataProprietorHolderData');
        const dataProprietorHolderWork = formatText('mortgageRequestPanel-dataProprietorHolderWork');
        const dataProprietorHolderEconomic = formatText('mortgageRequestPanel-dataProprietorHolderEconomic');
        const dataProprietorIrpfIcon = (isCheckedCirbe && operationProcessId) || (!isCheckedCirbe && operationProcessId)
            ? formatText('mortgageRequestPanel-checkCIRBEflagON_viewDetails') 
            : formatText('mortgageRequestPanel-dataProprietorIrpfIcon');
        const dataProprietorLaboralLifeIcon = (isCheckedCirbe && operationProcessId) || (!isCheckedCirbe && operationProcessId)
            ? formatText('mortgageRequestPanel-checkCIRBEflagON_viewDetails') 
            : formatText('mortgageRequestPanel-dataProprietorLaboralLifeIcon');
        const dataPersonalLifeIcon = (isCheckedCirbe && operationProcessId) || (!isCheckedCirbe && operationProcessId)
            ? formatText('mortgageRequestPanel-checkCIRBEflagON_viewDetails') 
            : formatText('mortgageRequestPanel-mortgageRequestPanel_identificationDocument');
        const titularTitles = [
            formatText('mortgageRequestPanel-dataProprietorNumTitleDefault'),
            formatText('mortgageRequestPanel-dataProprietorNumTitle1'),
            formatText('mortgageRequestPanel-dataProprietorNumTitle2'),
            formatText('mortgageRequestPanel-dataProprietorNumTitle3'),
            formatText('mortgageRequestPanel-dataProprietorNumTitle4')
        ];

        const isEmptyEmploymentSituation =
            employmentSituation === '' || employmentSituation === 'UNKNOWN';

        const itemId = 'mortgageRequestProprietor' + proprietorNum;
        const labelTipoTitular =
            proprietorNum > 0 && proprietorNum < 5
                ? titularTitles[proprietorNum]
                : titularTitles[0];

        const dinamicLink = this.getRoutesFromStatus(proprietorNum);
        const linkPersonalData = dinamicLink[0];
        const linkWorkData = dinamicLink[1];
        const linkEconomicData = dinamicLink[2];

        const idCea = get(ceaInfo, 'idCea', '');
        const fechaGenCea = get(ceaInfo, 'fechaGenCea', '');
        const codigoCea = get(ceaInfo, 'codigoCea', []);
        const hasCeaCode = !!idCea && !!fechaGenCea && codigoCea.length === 6;

        let isIrpf = documentIrpf;
        let isBuildDeleteButton;
        let modal;

        if (proprietorNum > 1 && proprietorNum < 5 && isApprovedDataProprietor && !isCheckedCirbe) {
            isBuildDeleteButton = this.buildDeleteButton();
        }

        if (this.state.isOpenModal) {
            const modalConfig = this.configModalOptions();
            modal = Modal(modalConfig);
        }

        if (isEmptyEmploymentSituation) {
            isIrpf = 'UNKNOWN';
        }

        const laboralLifeStatusIcon = OKStatusIcon({ status: documentLaboralLife, hasCeaCode: hasCeaCode });
        const irpfStatusIcon = OKStatusIcon({ status: isIrpf });
        const linkToPersonalDataElement = !hideLinks && (
            <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente" />
        );
        const linkToWorkDataElement = !hideLinks && (
                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente" />
        );

        return (
            <div id={itemId} className="mortgage-request-manager-panel-steps__item">
                <div className="mortgage-request-manager-panel-steps__header">
                    {isBuildDeleteButton}
                    <h4>
                        {labelTipoTitular}
                    </h4>
                </div>
                <ul className="list-unstyled mortgage-request-manager-panel-steps__list">
                    <li>
                        <div className="row">
                            <div className="col-xs-6">
                                <p>
                                    {dataProprietorHolderData}
                                </p>
                            </div>
                            <div className="col-xs-1">
                                {laboralLifeStatusIcon}
                            </div>

                            <div className="col-xs-5 area">
                                <Link to={linkPersonalData}>
                                    <div>
                                        <p className="descripcion">
                                            {dataPersonalLifeIcon}
                                        </p>
                                    </div>
                                    {linkToPersonalDataElement}
                                </Link>
                            </div>

                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className="col-xs-6">
                                    <p>
                                        {dataProprietorHolderWork}
                                    </p>
                            </div>
                            <div className="col-xs-1">
                                    {laboralLifeStatusIcon}
                            </div>

                            <div className="col-xs-5 area">
                                <Link to={linkWorkData}>
                                    <div>
                                        <p className="descripcion">
                                            {dataProprietorLaboralLifeIcon}
                                        </p>
                                    </div>
                                    {linkToWorkDataElement}
                                </Link>
                            </div>

                        </div>
                    </li>
                    <li>
                        <div className="row">
                            <div className="col-xs-6">
                                <p>
                                    {dataProprietorHolderEconomic}
                                </p>
                            </div>
                            <div className="col-xs-1">
                                {irpfStatusIcon}
                            </div>

                            <div className="col-xs-5 area">
                                {
                                    linkEconomicData
                                        ? (
                                            <Link to={linkEconomicData}>
                                                <div>
                                                    <p className="descripcion">
                                                        {dataProprietorIrpfIcon}
                                                    </p>
                                                </div>
                                                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente" />
                                            </Link>
                                        )
                                        : (
                                            <div>
                                                <p className="disabled">
                                                    {dataProprietorIrpfIcon}
                                                </p>
                                            </div>
                                        )
                                }

                            </div>

                        </div>
                    </li>
                </ul>
                {modal}
            </div>
        );
    }
}

MortgageRequestDataProprietorBodyItem.propTypes = {
    idExpediente: PropTypes.number,
    proprietorNum: PropTypes.number,
    numclienteobcd: PropTypes.string,
    proprietorDocumentType: PropTypes.string,
    proprietorDocumentId: PropTypes.string,
    employmentSituation: PropTypes.string,
    documentLaboralLife: PropTypes.string,
    ceaInfo: PropTypes.object,
    documentIrpf: PropTypes.string,
    dataProprietorsDelete: PropTypes.object,
    onRequestDataProprietor: PropTypes.func,
    onDelete: PropTypes.func,
    onSet: PropTypes.func,
    dataPropietorState: PropTypes.object,
    isApprovedDataProprietor: PropTypes.bool,
    currentState: PropTypes.string,
    hideLinks: PropTypes.bool,
    stepsValidation: PropTypes.object,
    isClientWithoutAccounts: PropTypes.bool
};

MortgageRequestDataProprietorBodyItem.defaultProps = {
    stepsValidation: []
}

module.exports = MortgageRequestDataProprietorBodyItem;
